
export const LANDING = '/';
export const UPLOAD = '/upload';
export const POSTS = '/posts';
export const SEARCH= '/search';
export const POST = '/post';
